import './RequiredFieldStar.css';

function RequiredFieldStar() {
  return <span className="RequiredFieldStar">*</span>;
}

export default RequiredFieldStar;
